import { render } from "./PatientDistributionChart.vue?vue&type=template&id=5b695a33&scoped=true&ts=true"
import script from "./PatientDistributionChart.vue?vue&type=script&lang=ts"
export * from "./PatientDistributionChart.vue?vue&type=script&lang=ts"

import "./PatientDistributionChart.vue?vue&type=style&index=0&id=5b695a33&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b695a33"]])

export default __exports__